<template>
  <div class="index">
    <div class="home_tit">
      <div class="home_tit_top" style="background: var(--bg-color)">
        <div class="home_tit_middle"">
          <!-- <img src="../../assets/images/4-002.png" alt="" /> -->
          <span style="color: #fff; margin-left: 5px">
            {{ $t("m.sy_span0") }}</span
          >
        </div>
       <div class="home_tit_right">
           <!--  <span style="color: #fff" @click="goTo(212)">
            {{ $t("m.fw_span0") }}
          </span>
          <img
            @click="goTo(12)"
            src="../../assets/images/new/icon1.png"
            style="margin-right: 10px"
          />   -->
        </div> 
      </div>
    </div>

    <div style="margin-top: 50px; padding: 0 15px; background: var(--bg-color)">
      <!-- <div
        style="
          white-space: nowrap;
          width: 100%;
          height: 80px;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
        "
      >
        <div
          v-for="(item, index) in blocks"
          @click="goTo(item.id)"
          :key="item.id"
          style="
            margin-right: 0px;
            text-align: center;
            border-radius: 6px;
            margin-top: 10px;
            position: relative;
            color: #333;
          "
        >
          <div class="home_block_list_img"><img :src="item.img" /></div>
          <p class="ppp">{{ $t("m.sy_list1")[index] }}</p>
        </div>
      </div> -->
    </div>
    <div class="home-notice-section">
      <div class="home-notice-card">
        <div class="home_msg">
          <div class="home_msg_con">
            <div
              class="home-notice-help"
              v-for="(item, index) in gglist"
              :key="index"
              @click="dianjilb(item.id)"
            >
              <div class="home-notice-help__title">{{ item.title }}</div>
              <span class="home-notice-help__date">{{
                createDate(item.created_at)
              }}</span>
              <img
                src="../../assets/images/licai/right.png"
                class="home-notice-help__arrow"
                alt=""
              />
            </div>
            <van-notice-bar
              v-if="reRender"
              class="home-notice-marquee"
              :text="activityRuleText"
              :scrollable="true"
              :speed="50"
              :delay="1"
              color="#333"
              background="transparent"
            >
              <template #left-icon>
                <img
                  class="home-notice-horn"
                  src="../../assets/images/new/laba.png"
                  alt=""
                />
              </template>
            </van-notice-bar>
          </div>
        </div>
      </div>
    </div>
    <div v-if="homePopupVisible" class="home-popup-mask" @click.self="closeHomePopup">
      <section class="home-popup">
        <button class="home-popup-close" type="button" aria-label="关闭" @click="closeHomePopup">×</button>
        <!-- <h2>{{ popupConfig.title || "温馨提示" }}</h2> -->
        <div class="home-popup-content" v-html="popupConfig.content"></div>
        <van-button block type="danger" @click="closeHomePopup">关闭</van-button>
      </section>
    </div>
    <div class="home-banner-section">
      <img
        @click="quhuzhuan()"
        src="../../assets/images/new/banner.jpg"
        class="home-banner-image"
        alt=""
      />
    </div>
    <div class="home-shortcuts-section">
      <div
        class="home_block am-cf"
        style="background: #fff; border-radius: 10px"
      >
        <div
          class="home_block_list am-fl"
          style="width: 20%"
          v-for="(item, index) in blocks1"
          @click="goTo(item.id)"
          :key="item.id"
        >
          <div class="home_block_list_img" style="width: 35px; height: 35px">
            <img :src="item.img" />
          </div>
          <p style="font-size: 12px; color: #333">
            {{ $t("m.sy_list2")[index] }}
          </p>
        </div>
      </div>
    </div>

<!-- 养老金入口 -->
<div class="ylj-entry" @click="$router.push({ path: '/Ylj' })">
  <img src="../../assets/images/ylj.jpg" alt="养老金">
</div>

    <div class="meiribox">
      <div class="mbox">
        <div class="boxtop">
          <div style="font-size: 20px; font-weight: bold; color: #000">
            天天领福利
          </div>
        </div>
        <div class="boxtop" style="margin-top: 10px">
          <div style="font-size: 18px; font-weight: bold; color: #000000">
            每日签到获得1个黄金碎片
          </div>
          <div
            class="benefit-sign-button"
            :class="{ signed: signedToday }"
            @click="$router.push({ path: '/Signln' })"
          >
            {{ signedToday ? "已签到" : "今日签到" }}
          </div>
        </div>
      </div>
    </div>

    <section class="mall-preview">
      <div class="mall-preview__header">
        <strong>积分商城</strong>
        <button type="button" @click="$router.push({ path: '/JfList' })">更多</button>
      </div>
      <div class="mall-preview__row" v-if="mallPreviewList.length">
        <button
          v-for="item in mallPreviewList"
          :key="item.id"
          type="button"
          class="mall-preview__item"
          @click="$router.push({ path: '/JfContent/' + item.id })"
        >
          <img :src="item.image" :alt="item.title" />
          <span>{{ item.title }}</span>
          <b>{{ parseInt(item.price, 10) }}</b>
        </button>
      </div>
      <div v-else class="mall-preview__empty">暂无商品</div>
    </section>

    <section class="policy-news">
      <div class="policy-news__header">
        <h3>政策动态</h3>
        <button type="button" @click="wayToArticle">
          查看更多 <span>›</span>
        </button>
      </div>
      <div
        class="policy-news__item"
        v-for="(item, index) in newsList"
        :key="item.id || index"
        @click="
          $router.push({ name: 'article_detail', query: { id: item.id } })
        "
      >
        <span class="policy-news__icon"></span>
        <div class="policy-news__text">
          <div class="policy-news__title">{{ item.title }}</div>
          <div class="policy-news__sub">
            {{ item.synopsis || item.title }}
          </div>
        </div>
        <div class="policy-news__right">
          <span>{{ policyDate(item.created_at) }}</span>
          <i>›</i>
        </div>
      </div>
    </section>

    <section class="policy-news">
      <div class="policy-news__header">
        <h3>视频会议</h3>
        <button type="button" @click="wayToMeeting">
          查看更多 <span>›</span>
        </button>
      </div>
      <div
        class="policy-news__item"
        v-for="(item, index) in meetingPreviewList"
        :key="item.id || index"
        @click="
          $router.push({ name: 'videoMeetingDetail', query: { id: item.id } })
        "
      >
        <span class="policy-news__icon"></span>
        <div class="policy-news__text">
          <div class="policy-news__title">{{ item.title }}</div>
          <div class="policy-news__sub">
            {{ item.short || item.title }}
          </div>
        </div>
        <div class="policy-news__right">
          <span>{{ policyDate(item.created_at) }}</span>
          <i>›</i>
        </div>
      </div>
    </section>
    <div
      style="z-index: 1000"
      v-if="yaoqi && detailData && !popupConfig.on_off"
      class="mask"
      @click="yaoqi1"
    >
      <div class="legacy-popup-shell">
        <div
          class="mask-modal modaltwo legacy-popup"
        >
          <div class="legacy-popup-scroll">
            <div
              v-html="detailData.content"
              class="content legacy-popup-content"
            ></div>
          </div>
          <div
            @click="yaoqi1"
            style="
              left: 20px;
              right: 20px;
              position: absolute;
              bottom: 15px;
              margin: 0 auto;
              text-align: center;
              line-height: 40px;
              border-radius: 30px;
              color: #a56400;
              background: linear-gradient(to bottom, #f7e2bf, #ffcd7c);
              font-size: 14px;
              font-weight: bold;
            "
          >
            我已了解
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Socket from "@libs/chat";
import $store from "../../store";
import request from "@utils/request";
import { goodsImage, rewriteHtmlAssets } from "@utils/goodsImage";
import "@assets/css/swiper.min.css";
import { getCategory } from "@api/store";

var vm = null;
export default {
  name: "Index",
  props: {},
  components: {},
  data: function() {
    return {
      maichubi: 63.47,
      mairubi: 36.53,
      maichubi1: 64.01,
      mairubi1: 35.99,
      mytime: "",
      socket: null,
      detailData: null,
      yaoqi: true,
      curStartTime: "2019-07-31 08:00:00",
      laitime: "",
      day: "0",
      hour: "00",
      min: "00",
      second: "00",
      jinyinIndex: 0,
      appDownloadUrl: "",
      jinyin: {
        jin: 1.0004,
        type1: true,
        fudu1: "+0.0002",
        min1: "1.0000",
        max1: 1.0004,
        bfb1: "-0.0001%",
        yin: 6.35,
        type2: false,
        fudu2: -0.06,
        bfb2: "-0.07%",
        xin: 6.34,
        type3: true,
        fudu3: +0.03,
        bfb3: "+0.04%"
      },
      selects: 0,
      reRender: true,
      show: false,
      types: 0,
      token: "",
      signedToday: false,
      swiperOption: {
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          click: function() {
            const realIndex = this.realIndex;
            vm.dianjilb(realIndex);
          }
        }
      },
      image:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F015ef657bc11150000012e7eafa2e0.png%402o.png&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1634556413&t=2fb650f58dfd37bf68e8ffd138c2dc73",
      blocks1: [
        {
          id: 0,
          img: require("@/assets/images/home/home6.png"),
          title: "每日签到"
        },
        //{
        //  id: 5,
        //  img: require("@/assets/images/home/home7.png"),
        //  title: "会员等级"
        //},

        //{
        //  id: 4,
        //  img: require("@/assets/images/home/home8.png"),
        //  title: "实名认证"
        //},
        {
          id: 6,
          img: require("@/assets/images/home/home9.png"),
          title: "我的团队"
        },
        //{
        //  id: 8,
        //  img: require("@/assets/images/home/home10.png"),
        //  title: "安全保障"
        //},
         {
         id: 8151,
         img: require("@/assets/images/home/yqhy.png"),
         title: "邀请好友"
        },
        {
         id: 9,
         img: require("@/assets/images/home/home11.png"),
         title: "幸运抽奖"
        },
        {
         id: 8152,
         img: require("@/assets/images/home/APP.png"),
         title: "APP下载"
        },
        //{
        //  id: 1002,
        //  img: require("@/assets/images/home/home13.png"),
        //  title: "日利宝"
        //},
        //{
        ////  id: 1003,
        //  img: require("@/assets/images/home/home14.png"),
        //  title: "我的资产"
        //},
      ],
      blocks: [
        {
          id: 1,
          img: require("@/assets/images/home/home1.png"),
          title: "我要充值"
        },
        {
          id: 2,
          img: require("@/assets/images/home/home2.png"),
          title: "我要提现"
        },
        {
          id: 7,
          img: require("@/assets/images/home/home3.png"),
          title: "公司资质"
        },
        {
          id: 45,
          img: require("@/assets/images/home/home4.png"),
          title: "邀请好友"
        },
        {
          id: 3,
          img: require("@/assets/images/home/home5.png"),
          title: "每日签到"
        }
      ],
      // 资讯
      newsList: [],
      meetingList: [],
      category: [],
      // 商品参数
      products: [],
      gglist: [],
      activityRuleText:
        "一、每日签到：用户每日完成签到，可获得1个黄金碎片。每个账号每日仅可签到1次。当日完成签到后，黄金碎片将自动计入个人账户。　二、邀请好友奖励：成功邀请好友完成注册，可获得额外的黄金碎片抽取机会：累计邀请10人注册获得1次黄金碎片抽取机会；累计邀请50人注册获得2次；累计邀请100人注册获得3次。邀请人数限本人邀请，达到对应邀请人数后，可进入黄金碎片抽取页面参与抽取。　三、黄金碎片兑换：累计获得指定数量的黄金碎片后，可按照对应档位申请兑换实物奖励：100个黄金碎片兑换3克圆形金质纪念币×1枚；200个兑换15克梅花形金质纪念币×1枚；300个兑换150克圆形金质纪念币×1枚；400个兑换500克圆形金质纪念币×1枚；500个兑换1公斤梅花形金质纪念币×1枚；600个兑换10公斤圆形金质纪念币×1枚；700个终极兑换：六款金质纪念币各1枚，共6枚整套。　四、特别说明：1.黄金碎片仅作为本活动内部奖励兑换凭证使用，不等同于黄金、人民币或数字人民币，不具备货币属性及现金价值。2.黄金碎片不得提现、转账或作为支付工具使用。3.如本活动并非由中国人民银行主办。　注：兑换积分商城里的纪念币和购买商品一样，兑换后减去对应的余额。例如：剩余200个黄金碎片，兑换15克（100个）后，还剩余100个。",
      id: "ceshi",
      mallProducts: [],
      popupConfig: { on_off: 0, title: "", content: "" },
      homePopupVisible: false,
      digitalYuan: 1,
    };
  },
  beforeDestroy() {
    this.socket && this.socket.close();
  },
created() {
  vm = this;
  this.token = $store.state.app.token;
  let yy = localStorage.getItem("lang");
  if (yy) {
    if (yy == "en-US") {
      this.$i18n.locale = "en-US";
    } else {
      this.$i18n.locale = "zh-CN";
    }
  }

  request.get("/api/v1/home/popup", {}, { login: false }).then(res => {
    const payload = res && res.data ? res.data : res;
    if (payload && payload.code === 200 && payload.data) {
      this.popupConfig = Object.assign({}, payload.data, {
        content: this.decodePopupHtml(payload.data.content)
      });
      this.homePopupVisible = Boolean(Number(payload.data.on_off) && payload.data.content);
    }
  }).catch(() => {});

  request.get("/fund/project/all", {}, { login: false }).then(res => {
    const payload = res && res.data ? res.data : res;
    if (payload && payload.data) {
      this.appDownloadUrl = payload.data.app_url || "";
    }
  }).catch(() => {
    this.appDownloadUrl = "";
  });
},
  activated() {
    this.reRender = false;
    setTimeout(() => {
      this.reRender = true;
    }, 10);
    this.loadSignStatus();
  },
  mounted: function() {
    this.detime();
    this.detime1();
    this.socket = new Socket();
    this.socket.vm(this);

    this.$on("onMessage", data => {
      this.jinyinIndex = 1;
      if (data.length > 50) {
        // console.log("数组数据：");
        // console.log(JSON.parse(data[0]));
      }
      if (data.code) {
        if (data.code == "0" && data.data.length > 0) {
          if (data.data[0].usdCny) {
            let cny = data.data[0].usdCny;
            let cce = (cny * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            if (this.jinyin.xin <= cny) {
              this.jinyin.type3 = true;
            } else {
              this.jinyin.type3 = false;
            }
            this.jinyin.yin = cce;
            this.jinyin.xin = cny;
          }
        }
      }
      if (data.arg) {
        if (data.arg.channel == "tickers" && data.arg.instId == "USDT-USDK") {
          if (data.data.length > 0) {
            if (this.jinyin.jin <= data.data[0].last) {
              this.jinyin.type1 = true;
            } else {
              this.jinyin.type1 = false;
            }
            this.jinyin.jin = data.data[0].last; //最新价
            this.jinyin.max1 = data.data[0].high24h; //最高价
            this.jinyin.min1 = data.data[0].low24h; //最低价
            let kai = data.data[0].open24h; //开盘价
            let mairu = parseFloat(data.data[0].bidSz); //左边买入量
            let mairu1 = parseFloat(data.data[0].bidSz) - 30000; //右边买入量1
            let maichu = parseFloat(data.data[0].askSz); //左边卖出量
            let maichu1 = parseFloat(data.data[0].askSz) - 30000; //右边卖出量1
            let mairubi = ((mairu / (mairu + maichu)) * 100).toFixed(2); //左边买入比例
            let maichubi = (100 - mairubi).toFixed(2); //左边卖出比例
            this.mairubi = mairubi;
            this.maichubi = maichubi;

            let mairubi1 = ((mairu1 / (mairu1 + maichu1)) * 100).toFixed(2); //右边买入比例
            let maichubi1 = (100 - mairubi1).toFixed(2); //右边卖出比例
            this.mairubi1 = mairubi1;
            this.maichubi1 = maichubi1;
            let cha = (this.jinyin.jin - kai).toFixed(4);
            if (cha >= 0) {
              this.jinyin.fudu1 = "+" + cha;
              this.jinyin.bfb1 = "+" + (cha / kai).toFixed(4) + "%";
            } else {
              this.jinyin.fudu1 = cha;
              this.jinyin.bfb1 = (cha / kai).toFixed(4) + "%";
            }

            let cce = (this.jinyin.yin * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            this.jinyin.yin = cce;
          }
        }
      }

      let huilv = this.jinyin.jin * this.jinyin.yin;
      let ss = $store.state.app.huilv;
      if (huilv >= ss) {
        this.shangxia = true;
      } else {
        this.shangxia = false;
      }
      this.$store.commit("HUILV", huilv);
    });
    this.$on("socket_error", () => {
      // this.$dialog.error("连接失败");
    });
    this.$on("err_tip", data => {
      // this.$dialog.error(data.msg);
    });
    this.$on("socket_open", () => {
      // this.$dialog.error("连接成功");
    });
    this.curStartTime = "2022-02-09";
    this.countTime();
    let that = this;
    request
      .post(
        "/api/v1/article/article/list",
        {
          cid: 15,
          page: 1
        },
        {
          login: false
        }
      )
      .then(res => {
        let gglist1 = res.data.data;
        if (gglist1.length > 0) {
          const first = Object.assign({}, gglist1[0]);
          first.image = goodsImage(first.image);
          first.content = rewriteHtmlAssets(first.content);
          that.detailData = first;
        }
      });
    this.$nextTick(function() {
      getCategory().then(res => {
        let list = [];
        for (let i = 0; i < res.data.data.length; i++) {
          if (i < 4) {
            list.push(res.data.data[i]);
          }
        }
        // 保留两个产品。
        for (let j = 0; j < list.length; j++) {
          if (list[j].list.length > 2) {
            list[j].list.splice(2, list.length + 1);
          }
        }
        this.category = list;
      });
      request
        .post(
          "/api/v1/article/article/list",
          {
            cid: 7,
            page: 1
          },
          {
            login: false
          }
        )
        .then(res => {
          this.gglist = res.data.data;
           this.digitalYuan = Number(res && res.data && res.data.digital_yuan) === 0 ? 0 : 1;
          let val = Math.max(...this.gglist.map(a => a.sort));
          let saa = [];
          for (let index = 0; index < this.gglist.length; index++) {
            const dic = this.gglist[index];
            if (dic.sort == val) {
              saa.push(dic);
            }
          }
          this.gglist = saa;
        });
    });
    // 活动列表
    request
      .post(
        "/api/v1/article/cat/all",
        {},
        {
          login: false
        }
      )
      .then(res => {
        const categories = (res && res.data && res.data.data) || [];
        const named = categories.find(
          cat => cat && cat.name && String(cat.name).indexOf("政策") !== -1
        );
        let list = named && named.list ? named.list.slice() : [];
        if (!list.length) {
          list = categories.reduce((all, cat) => {
            return all.concat((cat && cat.list) || []);
          }, []);
        }
        this.newsList = list.map(item => {
          return Object.assign({}, item, {
            image: goodsImage(item.image)
          });
        });
      });
    request
      .get(
        "/api/v1/video/list",
        { limit: 5 },
        {
          login: false
        }
      )
      .then(res => {
        const payload = res && res.data ? res.data : res;
        this.meetingList = ((payload && payload.data) || []).map(item => {
          return Object.assign({}, item, {
            image: goodsImage(item.image)
          });
        });
      })
      .catch(() => {
        this.meetingList = [];
      });
    this.loadMallPreview();
  },
  computed: {
    mallPreviewList() {
      return (this.mallProducts || []).slice(0, 8);
    },
    meetingPreviewList() {
      return (this.meetingList || []).slice(0, 5);
    },
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return h + ":" + m;
      };
    }
  },
  methods: {
    decodePopupHtml(content) {
      const value = String(content || "");
      if (!/&(?:lt|gt|amp|quot|#39);/i.test(value)) return value;
      const textarea = document.createElement("textarea");
      textarea.innerHTML = value;
      return textarea.value;
    },
    closeHomePopup() {
      this.homePopupVisible = false;
    },
    loadMallPreview() {
      request
        .get("/shop/goods/cat", {}, { login: false })
        .then(res => {
          const payload = res && res.data ? res.data : res;
          const raw = payload && payload.data;
          const cats = Array.isArray(raw)
            ? raw
            : raw && typeof raw === "object"
              ? Object.keys(raw).map(key => raw[key])
              : [];
          const list = [];
          cats.forEach(cat => {
            (cat && cat.list ? cat.list : []).forEach(item => {
              list.push({
                id: item.id,
                title: item.title,
                price: item.price,
                image: goodsImage(item.images || item.image)
              });
            });
          });
          this.mallProducts = list;
        })
        .catch(() => {
          this.mallProducts = [];
        });
    },
    loadSignStatus() {
      const token = this.token || $store.state.app.token;
      if (!token) {
        this.signedToday = false;
        return;
      }
      request
        .get("/shop/sign/status", {}, { login: true })
        .then(res => {
          const status =
            res.data && res.data.data ? Number(res.data.data.status) : 0;
          this.signedToday = status === 1;
        })
        .catch(() => {});
    },
    wayToArticle() {
      this.$router.push({ path: "/article" });
    },
    wayToMeeting() {
      this.$router.push({ path: "/videoMeeting" });
    },
    policyDate(val) {
      if (val === 0 || val) {
        const text = String(val);
        if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
          return text.slice(0, 10);
        }
        const n = Number(val);
        if (n > 0) {
          const date = new Date(n < 1e12 ? n * 1000 : n);
          if (!isNaN(date.getTime())) {
            const m = date.getMonth() + 1;
            const d = date.getDate();
            return (
              date.getFullYear() +
              "-" +
              (m < 10 ? "0" : "") +
              m +
              "-" +
              (d < 10 ? "0" : "") +
              d
            );
          }
        }
        return text;
      }
      return "";
    },
quhuzhuan() {
  if (this.digitalYuan !== 1) {
    this.$dialog.error("目前资产申报已经结束，详情请咨询在线客服！");
    return;
  }
  this.$router.push({
    path: "/assetRegister"
  });
},
    detime() {
      let date = new Date();
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.mytime = MM + "月" + d + "日" + h + "时" + m + "分" + s + "秒 ";
    },
    detime1() {
      let date = new Date();
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.laitime = y + "-" + MM + "-" + d + " " + h + ":" + m;
    },
    yaoqi1() {
      this.yaoqi = false;
    },
    // 倒计时
    countTime() {
      // 获取当前时间
      let date = new Date();
      let now = date.getTime();
      // 设置截止时间
      let endDate = new Date(this.curStartTime); // this.curStartTime需要倒计时的日期
      let end = endDate.getTime();
      // 时间差
      let leftTime = end - now;
      // 定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        // 天
        this.day = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        // 时
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.hour = h < 10 ? "0" + h : h;
        // 分
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        this.min = m < 10 ? "0" + m : m;
        // 秒
        let s = Math.floor((leftTime / 1000) % 60);
        this.second = s < 10 ? "0" + s : s;
      } else {
        this.day = 0;
        this.hour = "00";
        this.min = "00";
        this.second = "00";
      }
      // 等于0的时候不调用
      if (
        Number(this.hour) === 0 &&
        Number(this.day) === 0 &&
        Number(this.min) === 0 &&
        Number(this.second) === 0
      ) {
        return;
      } else {
        // 递归每秒调用countTime方法，显示动态时间效果,
        setTimeout(this.countTime, 1000);
      }
    },
    dianji(e) {
      this.selects = e;
    },
    dianjilb(index) {
      this.$router.push({
        name: "article_detail",
        query: {
          id: index
        }
      });
    },
    details: function(id) {
      this.$router.push({
        path: "/detail/" + id
      });
    },
    goTo: function(url) {
      switch (url) {
        case "user":
          this.$router.push({
            path: "/user"
          });
          break;
        case 11:
          this.$router.push({
            path: "/moneyDetail"
          });
          break;
        case 12:
          this.$router.push({
            path: "/my-assets"
          });
          break;
        case 211:
          this.$router.push({
            path: "/language"
          });
          break;
        case 212:
          this.$router.push({ path: "/qiehuan" });
          break;
      }

      if (url == 0) {
        // 充值
        this.$router.push({
          path: "/Signln"
        });
      }
      if (url == 1) {
        // 充值
        this.$router.push({
          path: "/CzContent"
        });
      }
      if (url == 2) {
        // 提现
        this.$router.push({
          path: "/txCash"
        });
      }
      if (url == 3) {
        // 邀请好友
        this.$router.push({
          path: "/invitation"
        });
      }
      if (url == 4) {
        // 实名认证
        this.$router.push({
          path: "/memmber_business"
        });
      }
      if (url == 5) {
        //会员等级
        this.$router.push({
          path: "/Grade"
        });
      }
      if (url == 6) {
        //我的团队
        this.$router.push({
          path: "/team"
        });
      }
      if (url == 1001) {
        //我的团队
        this.$router.push({
          path: "/moneyDetail"
        });
      }
      if (url == 1002) {
        //我的团队
        this.$router.push({
          path: "/rilibaoindex"
        });
      }
      if (url == 1003) {
        //我的团队
        this.$router.push({
          path: "/moneyDetail"
        });
      }
      if (url == 1004) {
        //我的团队
        this.$router.push({
          path: "/my-assets"
        });
      }
      if (url == 7) {
        //平台介绍
        this.$router.push({
          name: "GoodsClass"
          // query: {
          //  id: 18
          // }
        });
      }
      if (url == 45) {
        //平台介绍
        this.$router.push({
          name: "article_detail",
          query: {
            id: 18
          }
        });
      }
      if (url == 77) {
        //平台介绍
        this.$router.push({
          name: "article_detail",
          query: {
            id: 17
          }
        });
      }
      if (url == 8) {
        //安全保障
        this.$router.push({
          name: "article_detail",
          query: {
            id: 51
          }
        });
      }
      if (url == 9) {
        this.$router.push({
          // path: "/customerService"
          path: "/user/zhuanpan"
        });
      }
      if (url == 10) {
        //客户中心
        this.$router.push({
          path: "/user"
        });
      }
      if (url == 111) {
        //客户中心
        this.$router.push({
          path: "/article"
        });
      }
      if (url == 112) {
        //客户中心
        this.$router.push({
          path: "/qiehuan"
        });
      }
      if (url == 8151) {
        //邀请好友
        this.$router.push({
          path: "/invitation"
        });
      }
      if (url == 8152) {
        if (!this.appDownloadUrl) {
          this.$dialog.error("APP下载地址暂未设置");
          return;
        }
        window.location.href = this.appDownloadUrl;
      }
    }
  }
};
</script>
<style scoped lang="less">
.meiribox {
  width: auto;
  margin: 12px 10px 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .mbox {
    background-color: #fcfcfc;
    width: 100%;
    min-height: 132px;
    border-radius: 10px;
    padding: 22px 16px;

    .boxtop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;

      .benefit-sign-button {
        flex: 0 0 96px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        width: 96px;
        border-radius: 30px;
        color: #fff;
        font-size: 14px;
        line-height: 1;
        background-color: var(--bg-color);
      }
      .benefit-sign-button.signed {
        background-color: #cccccc;
      }
    }
  }
}

.home-notice-section {
  padding: 12px 10px 0;
}

.home-notice-card {
  overflow: hidden;
  border-radius: 10px;
  background: #fff;
}

.home-banner-section,
.home-shortcuts-section {
  margin-top: 12px;
  padding: 0 10px;
}

.home-banner-section {
  overflow: hidden;
}

.home-banner-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 10px;
}

.home-popup-mask {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, .48);
}

.home-popup {
  position: relative;
  width: min(100%, 360px);
  max-height: min(78vh, 620px);
  overflow: auto;
  padding: 24px 20px 20px;
  border-radius: 12px;
  background: #fff;
  box-sizing: border-box;
}

.home-popup h2 {
  margin: 0 28px 16px 0;
  color: #222;
  font-size: 20px;
  line-height: 1.4;
}

.home-popup-content {
  margin-bottom: 20px;
  color: #555;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 15px;
  line-height: 1.7;
}

.home-popup-content /deep/ img {
  max-width: 100%;
  height: auto;
}

.home-popup-close {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  color: #999;
  font-size: 26px;
  line-height: 32px;
  cursor: pointer;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask-modal {
  border-radius: 5px;
}

.legacy-popup-shell {
  position: relative;
}

.legacy-popup {
  display: flex;
  flex-direction: column;
  width: calc(100vw - 24px);
  max-width: 366px;
  height: 78vh;
  max-height: 600px;
  padding: 20px 15px 70px;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #ff1900, #ff1900, #ff1900);
}

.legacy-popup-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: #fff;
}

.legacy-popup-content {
  min-height: 100%;
}

/deep/ .van-circle__text {
  color: #777;
  font-size: 12px;
}

/deep/ .listname:last-child {
  margin-right: 0 !important;
}

/deep/ .swiper-pagination-bullet {
  border: 2px solid #fff;
  background: #dfdfdf;
}

/deep/ .swiper-pagination-bullet-active {
  // 这以下的代码是你需要的
  background: #fff;
  border: 0px solid #fff;
}

.danshu {
  width: 90%;
  display: inline-block;
  margin-right: 10px;
  padding: 20px 15px 20px 15px;
  border-radius: 10px;
  position: relative;
  border: 0px solid #fff;
  background-size: 100% 100%;
  background-color: #e8e8e8;
}

.line-clamp2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.line-clamp1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.home_vip_block {
  border-right: 1px solid #eceeed;
  width: 50%;
  padding: 20px 0px;
}

.home_vip_block:last-child {
  border: 0px;
}

.home_tab_item {
  padding: 0px 0px;
}

.home_con_block {
  padding: 0px 15px;
  margin-top: 15px;
}

.home_con_text {
  width: 100%;
}

.home_con_list {
  margin-top: 10px;
}

.home_con_list_block {
  width: 50%;
}

.home_con_block img {
  width: 100%;
  height: 110px;
}

.name {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000;
}

.names {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #666;
  margin-left: 3%;
  padding: 3px 5px;
}

.trip {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #d3d3d3;
}

.home_tab_item_block {
  margin-top: 10px;
  font-size: 14px;
  width: 25%;
  margin-left: 5%;
  text-align: center;
  padding-bottom: 5px;
}

/* .home_tab_item_block:first-child{margin-left: 0px;} */
.home_tab_item_blocks {
  color: #ff1900;
  border-bottom: 3px solid #ff1900;
  font-size: 14px;
}

.home_vip_block img {
  width: 27px;
  height: 29px;
  margin: 0 auto;
  display: block;
}

.home_vip_block p {
  text-align: center;
  font-size: 13px;
  color: #000000;
  margin-top: 8px;
}

.home_vip_block:last-child img {
  width: 40px;
  height: 27px;
  margin: 0 auto;
  display: block;
}

.home_line {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 15px;
}

.home_line img {
  border-radius: 5px;
  height: 98px;
  flex: 1;
  margin-right: 1.5%;
}

.home_line img:first-child {
  width: 43%;
}

.home_line img:last-child {
  margin-right: 0px;
}

.home_block {
  margin-top: 0px;
  // background: #fff;

  padding: 5px 0px;
  padding-bottom: 15px !important;
}

.home_block_list {
  width: 24%;
  margin-top: 15px;
}

.home_block_list p,
.ppp {
  text-align: center;
  font-size: 13px;
  font-family: Microsoft YaHei;
  //   font-weight: 600;
  color: #fff;
  margin-top: 6px;
}

.home_block_list_img {
  width: 30px;
  height: 30px;
  margin: 0 auto;
  display: block;
  margin-bottom: 8px;
}

.home_block_list_img img {
  width: 100%;
  height: 100%;
}

.home_msg_con {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 21px;
}

.home-notice-help {
  display: flex;
  align-items: center;
  height: 30px;
  line-height: 30px;
}

.home-notice-help__title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: #333;
  font-size: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.home-notice-help__date {
  width: 40px;
  margin-left: 5px;
  color: #666;
  font-size: 11px;
  text-align: right;
}

.home-notice-help__arrow {
  width: 12px;
  height: 12px;
  margin-left: 5px;
}

.home-notice-marquee {
  height: 30px;
  padding: 0;
  font-size: 12px;
  line-height: 30px;
}

.home-notice-marquee /deep/ .van-notice-bar__wrap {
  min-width: 0;
}

.home-notice-horn {
  display: block;
  width: 15px;
  height: 15px;
  margin-right: 6px;
}

.home_msg .home-notice-horn {
  width: 15px;
  height: 15px;
}

.home_msg .home-notice-help__arrow {
  width: 12px;
  height: 12px;
}

.home_msg img {
  width: auto;
  height: 14px;
}

.home_msg {
  display: flex;
  align-items: center;
  min-height: 60px;
  margin: 0 8px;
  padding: 4px 0 6px;
}

.home_tit {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
}

.home_tit_top {
  height: 50px;

  display: flex;
  align-items: center;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_tit_left {
  width: 25%;
  display: flex;
  align-items: center;
}

.home_tit_left img {
  width: 23px;
  height: 23px;
}

.home_tit_left div {
  margin: 0 20px;
  color: #333;
  font-size: 16px;
}

.home_tit_middle {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 0px;
  color: #000;
  font-weight: bold;
  font-size: 18px;
}

.home_tit_middle img {
  width: 35px;
  height: 35px;
  margin-left: 6px;
}

.home_tit_middle {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 0px;
  color: #000;
  font-weight: bold;
  font-size: 18px;
}

.home_tit_right {
  padding-right: 10px;
  width: 160px;
  display: flex;
  align-items: center;
  color: #333;
  flex-direction: row-reverse;

  font-size: 15px;
  font-weight: bold;
}

.home_tit_right img {
  width: 22px;
  height: 22px;
  margin-left: 7px;
}

[v-cloak] {
  display: none;
}

/* 清除浮动*/
.am-fl {
  float: left;
}

.am-fr {
  float: right;
}

.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.am-cf {
  zoom: 1;
}

.overflow1 {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.index {
  background-color: #fff;
  background-image: url("../../assets/images/new/gradient-bg.png");
  background-size: cover;
  background-attachment: fixed;
  padding-bottom: 70px;
}

.index .follow {
  z-index: 100000;
}

.mall-preview {
  margin: 12px 10px 0;
  padding: 12px 10px 14px;
  border-radius: 10px;
  background: #fff;
}

.mall-preview__empty {
  padding: 18px 0 8px;
  color: #999;
  font-size: 13px;
  text-align: center;
}

.policy-news {
  margin: 12px 10px 0;
  padding: 14px 12px 4px;
  border-radius: 10px;
  background: #fff;
}

.policy-news__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.policy-news__header h3 {
  margin: 0;
  color: #222;
  font-size: 16px;
  font-weight: 600;
}

.policy-news__header button {
  border: 0;
  padding: 0;
  background: transparent;
  color: #999;
  font-size: 13px;
}

.policy-news__header span {
  font-size: 15px;
}

.policy-news__item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f2f2f2;
}

.policy-news__item:last-child {
  border-bottom: 0;
}

.policy-news__icon {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  margin-right: 10px;
  border-radius: 2px;
  background: #ff1900;
}

.policy-news__text {
  flex: 1;
  min-width: 0;
}

.policy-news__title {
  overflow: hidden;
  color: #222;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.policy-news__sub {
  margin-top: 4px;
  overflow: hidden;
  color: #b0b0b0;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.policy-news__right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-left: 8px;
  color: #c0c0c0;
  font-size: 12px;
}

.policy-news__right i {
  margin-left: 4px;
  font-style: normal;
  font-size: 16px;
  line-height: 1;
}

.mall-preview__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #222;
  font-size: 17px;
}

.mall-preview__header button {
  border: 0;
  background: transparent;
  color: #888;
  font-size: 13px;
}

.mall-preview__row {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.mall-preview__row::-webkit-scrollbar {
  display: none;
}

.mall-preview__item {
  flex: 0 0 108px;
  width: 108px;
  min-width: 108px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #333;
  text-align: left;
}

.mall-preview__item img {
  display: block;
  width: 108px;
  height: 108px;
  object-fit: cover;
  border-radius: 6px;
  background: #f5f5f5;
}

.mall-preview__item span,
.mall-preview__item b {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mall-preview__item span {
  margin-top: 6px;
  font-size: 12px;
}

.mall-preview__item b {
  margin-top: 3px;
  color: #ff1900;
  font-size: 11px;
  font-weight: 500;
}

.keep {
  text-align: center;
}

.productSort_block_left_xh {
  max-width: 220px;
  overflow: hidden;
  /*超出部分隐藏*/
  white-space: nowrap;
  /*禁止换行*/
  text-overflow: ellipsis;
  /*省略号*/
  margin-bottom: 5px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 36px;
}

.zuoce {
  // max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 13px;
  color: #666;
}

.zuoce1 {
  color: #666;
  font-size: 11px;
}

.productSort_block_left_dm {
  border: 1px solid #ffa68c;
  color: #ffa68c;
  padding: 2px 5px;
  border-radius: 2px;
  margin-left: 10px;
  font-size: 11px;
}

.productSort_block_last {
  padding: 0px 9px;
  align-items: center;
  display: flex;
}

.productSort_block_last_item:last-child {
  margin-left: 60px;
}

.productSort_block_left {
  display: flex;
  align-items: center;
  padding: 0 9px;
  margin-bottom: 6px;
  justify-content: space-between;
}

.productSort_con_list {
  padding: 10px 10px;

  border-radius: 10px;
}

.productSort_block {
  position: relative;

  width: 100%;
  background-color: #ffffff;
  padding: 10px 0px;
  margin-bottom: 10px;
}

.productSort_block img {
  width: 100%;
  height: 86px;
}

.productSort_top {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 0 6px;
  /* justify-content: space-between; */
}

.productSort_top_block {
  flex-shrink: 0;

  display: inline-block;
  margin-right: 14px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  text-align: center;
}

.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
}

.productSort_top_blocks {
  border-bottom: 2px solid #ff1900;
  color: #ff1900;
}

/deep/ .mask .content img {
  width: 100% !important;
}
.ylj-entry{
  margin:15px 15px 0;
  border-radius:10px;
  overflow:hidden;
  background:#fff;
  cursor:pointer;
}
.ylj-entry img{
  display:block;
  width:100%;
  height:auto;
}
</style>
